const selectCat = () => {
  const selectCategory = document.querySelectorAll('.js-update-cat');
  const selectMainCategory = document.querySelector('.js-update-maincat');
  if (selectCategory) {
    selectCategory.forEach(element => {
      element.addEventListener('change', () => {
        const request = new XMLHttpRequest();
        request.open('POST', '/blog/wp-admin/admin-ajax.php', true);
        request.setRequestHeader(
          'Content-Type',
          'application/x-www-form-urlencoded;',
        );
        request.onload = () => {
          element.parentElement.querySelector('.js-category-list').innerHTML =
            request.response;
        };
        const category =
          element.value === 'all' ? element.dataset.cat : element.value;
        request.send(`action=ks_get_categories&category=${category}`);
      });
    });
  }
  if (selectMainCategory) {
    selectMainCategory.addEventListener('change', e => {
      const request = new XMLHttpRequest();
      const container = e.target.parentElement;
      const selects = container.querySelectorAll('.js-update-cat');
      const checkedCat = e.target.value;
      const checkedSubCat = container.querySelector(
        `.js-update-cat[data-cat="${checkedCat}"]`,
      ).value;
      const category = checkedSubCat === 'all' ? checkedCat : checkedSubCat;
      request.open('POST', '/blog/wp-admin/admin-ajax.php', true);
      request.setRequestHeader(
        'Content-Type',
        'application/x-www-form-urlencoded;',
      );
      request.onload = () => {
        selects.forEach(select => {
          if (select.dataset.cat === checkedCat) {
            select.classList.add('is-active');
          } else {
            select.classList.remove('is-active');
          }
        });
        container.querySelector('.js-category-list').innerHTML =
          request.response;
      };
      request.send(`action=ks_get_categories&category=${category}`);
    });
  }
};
export default selectCat;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/bnppblog-chisel/src/scripts/modules/selectCat.js